import type { YearGroupItemGet } from '@whizz/api-model';
import type Teacher from '@whizz/api-client/dist/@types/model/Teacher';
import { useQuery } from 'react-query';
import { repository } from '@whizz/api-client';
import { QUERIES_IDS } from '../util/vars';
import { useIdentity } from '@whizz/react-identity';

const useYearGroups = () => {

  const { me } = useIdentity();
  const schoolId = (me as Teacher).getSchoolId();

  const yearGroupsQuery = useQuery<YearGroupItemGet[]>(
    [ QUERIES_IDS.YEAR_GROUPS ],
    () => repository.YearGroupRepository.allBySchoolId(schoolId!),
    {
      placeholderData: [],
    },
  );

  return [ yearGroupsQuery ];
};

export default useYearGroups;
